var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.883 20.5064L12.3598 19.6542L12.883 20.5064ZM19.9598 6.5619L18.9611 6.50949L19.9598 6.5619ZM5.75746 5.59141L11.7575 4.09141L11.2724 2.15113L5.27239 3.65113L5.75746 5.59141ZM12.2425 4.09141L18.2425 5.59141L18.7276 3.65113L12.7276 2.15113L12.2425 4.09141ZM18.9611 6.50949C18.5877 13.6241 15.587 17.673 12.3598 19.6542L13.4062 21.3586C17.2622 18.9915 20.5549 14.3022 20.9584 6.61432L18.9611 6.50949ZM11.6402 19.6542C8.41296 17.673 5.41229 13.6241 5.03887 6.50949L3.04162 6.61431C3.44513 14.3022 6.7378 18.9915 10.5938 21.3586L11.6402 19.6542ZM12.3598 19.6542C12.1383 19.7901 11.8617 19.7901 11.6402 19.6542L10.5938 21.3586C11.4572 21.8887 12.5428 21.8887 13.4062 21.3586L12.3598 19.6542ZM11.7575 4.09141C11.9167 4.0516 12.0833 4.0516 12.2425 4.09141L12.7276 2.15113C12.2499 2.0317 11.7501 2.0317 11.2724 2.15113L11.7575 4.09141ZM18.2425 5.59141C18.7 5.70577 18.9825 6.1024 18.9611 6.50949L20.9584 6.61432C21.0332 5.18846 20.0508 3.98193 18.7276 3.65113L18.2425 5.59141ZM5.27239 3.65113C3.94917 3.98193 2.96678 5.18845 3.04162 6.61431L5.03887 6.50949C5.0175 6.1024 5.30002 5.70577 5.75746 5.59141L5.27239 3.65113Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13M14 11H10",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthLogo);
export default __webpack_public_path__ + "static/media/health-logo.67d193923f0fd73041e0f8c024c5fd32.svg";
export { ForwardRef as ReactComponent };